import { render } from "./QuestionsSection.vue?vue&type=template&id=65581346&scoped=true"
import script from "./QuestionsSection.vue?vue&type=script&lang=js"
export * from "./QuestionsSection.vue?vue&type=script&lang=js"

import "./QuestionsSection.vue?vue&type=style&index=0&id=65581346&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65581346"]])

export default __exports__